import '../sass/icon-and-text.scss';

(() => {
    const players = document.querySelectorAll('.icon-and-text__animation dotlottie-wc');

    if (!players.length) return;

    const sizePlayer = (player) => {
        const box = player.parentElement;

        if (!box) return;

        const size = Math.round(box.getBoundingClientRect().width);

        if (!size) return;

        player.style.width = `${size}px`;
        player.style.height = `${size}px`;
    };

    const watchPlayer = (player) => {
        sizePlayer(player);

        let inView = false;
        let started = false;

        const tryPlay = () => {
            if (!inView || started) return;

            const dotLottie = player.dotLottie;

            if (!dotLottie || typeof dotLottie.play !== 'function') return;

            dotLottie.play();
            started = true;
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                inView = entry.isIntersecting;

                if (!inView) return;

                sizePlayer(player);
                tryPlay();
            });
        }, { threshold: 0.2 });

        observer.observe(player.parentElement || player);
        window.addEventListener('resize', () => sizePlayer(player));

        const bindPlayer = () => {
            const dotLottie = player.dotLottie;

            if (!dotLottie) {
                window.requestAnimationFrame(bindPlayer);
                return;
            }

            if (typeof dotLottie.addEventListener === 'function') {
                dotLottie.addEventListener('load', tryPlay);
            }

            tryPlay();
        };

        bindPlayer();
    };

    const start = () => players.forEach(watchPlayer);

    if (window.customElements?.get('dotlottie-wc')) {
        start();
    } else if (window.customElements) {
        window.customElements.whenDefined('dotlottie-wc').then(start);
    } else {
        start();
    }
})();
